import React, { createContext, useContext, useReducer } from "react";
import UsersReducer from "./UsersReducer";
import { getUserRequest } from "../../../shared/api/users"

export interface IUserContextType {
  user: any;
  getUser: () => void;
}

const initialState: IUserContextType = {
  user: undefined,
  getUser: () => {},
}

const UsersContext = createContext(initialState);

export const useUsers = () => useContext(UsersContext);

const UsersProvider = (props: any) => {
  const [state, dispatch] = useReducer(UsersReducer, initialState);

  const getUser = () => {
    getUserRequest().then(response =>
      dispatch({type: 'GET_USER', payload: response})
    );
  };

  return(
    <UsersContext.Provider value={{
      user: state.user,
      getUser: getUser,
    }}>
      {props.children}
    </UsersContext.Provider>
  )
}

export default UsersProvider;